"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Provider = void 0;
const react_1 = require("react");
const Context_1 = require("./Context");
const Pool_1 = require("./Pool");
/**
 * Объявляет контекст сервисов.
 */
class Provider extends react_1.Component {
    /**
     * @inheritdoc
     */
    render() {
        const { pool, children } = this.props;
        if (this.value == null || this.pool !== pool) {
            const finalPool = pool || new Pool_1.Pool();
            this.value = { pool: finalPool };
        }
        const { value } = this;
        return react_1.createElement(Context_1.context.Provider, { value }, children);
    }
}
exports.Provider = Provider;
